import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Volume2, VolumeX } from "lucide-react";
import { useLang } from "@/i18n";

const SKIP = ["/admin", "/chela", "/job", "/track", "/rate", "/pay", "/travel", "/book"];

export default function Jingle() {
  const { t } = useLang();
  const { pathname } = useLocation();
  const audio = useRef(null);
  const [muted, setMuted] = useState(() => localStorage.getItem("chela_jingle_muted") === "1");
  const hidden = SKIP.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (hidden || muted || audio.current) { return undefined; }
    const a = new Audio("/media/jingle.mp3");
    audio.current = a;
    const onGesture = () => { a.play().catch(() => {}); off(); };
    const off = () => ["pointerdown", "keydown", "touchstart"].forEach((e) => window.removeEventListener(e, onGesture));
    a.play().catch(() => ["pointerdown", "keydown", "touchstart"].forEach((e) => window.addEventListener(e, onGesture, { once: true })));
    return off;
  }, [hidden, muted]);

  if (hidden) { return null; }
  const toggle = () => {
    const m = !muted;
    setMuted(m);
    localStorage.setItem("chela_jingle_muted", m ? "1" : "0");
    if (m) { audio.current?.pause(); } else { audio.current = audio.current || new Audio("/media/jingle.mp3"); audio.current.currentTime = 0; audio.current.play().catch(() => {}); }
  };
  return (
    <button data-testid="jingle-toggle" onClick={toggle} aria-label={muted ? t("jingle_off") : t("jingle_on")} title={muted ? t("jingle_off") : t("jingle_on")}
      className="fixed right-5 bottom-40 md:right-auto md:left-4 md:bottom-6 z-40 h-11 w-11 rounded-full bg-white border border-[#E5E0D8] shadow-lg flex items-center justify-center text-[#E05624] hover:scale-105 transition-transform">
      {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
    </button>
  );
}
